import DataLoader from 'dataloader'

import { MortgageSourcingInput, SourceResponse } from '../generated/resolvers'
import request from '../requesters/default'
import { CdmGetAcreMortgageProductResponse } from '../service/luther/model'

export const MortgageProductLoader = new DataLoader((ids: string[]) =>
  Promise.all(ids.map((id) => fetchMortgageProductById(id))),
)

// This is used for mortgage products that have either been created
// by the user (existing mortgages, product transfers, etc) or sourced
// mortgage products that have been linked to a case via
// an instantiated mortgage
export const fetchMortgageProductById = async (productId: string) => {
  const response = await request.get<CdmGetAcreMortgageProductResponse>(`/mortgage_product/${productId}`)
  return response.data
}

export const sourceMortgages = async (input: MortgageSourcingInput) => {
  const response = await request.post<SourceResponse>(`/mortgage_product/source`, {
    source_details: input,
  })
  return {
    ...response.data,
    serialised_data: JSON.stringify(response.data),
  }
}
